import { brandLogo } from '../data/landingPageData';
import './Brand.css';

function Brand() {
  return (
    <a className="brand" href="/" aria-label="Crumbs home">
      <img src={brandLogo.src} alt={brandLogo.alt} />
      <span>Crumbs</span>
    </a>
  );
}

export default Brand;
